import {
  Enum_Commande_Methodepaiement,
  Enum_Commande_Status
} from '../../graphql/generated/graphql';

export const GET_STATUS_FROM_PAYMENT_METHOD = paymentMethod => {
  if (paymentMethod === Enum_Commande_Methodepaiement.Cheque)
    return Enum_Commande_Status.Paye;
  if (paymentMethod === Enum_Commande_Methodepaiement.Especes)
    return Enum_Commande_Status.Paye;
  if (paymentMethod === Enum_Commande_Methodepaiement.Cb)
    return Enum_Commande_Status.APayer;
  if (paymentMethod === Enum_Commande_Methodepaiement.MandatAdministratif)
    return Enum_Commande_Status.APayer;
  if (paymentMethod === Enum_Commande_Methodepaiement.Virement)
    return Enum_Commande_Status.APayer;
};
